exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centerizebtn button[data-v-2f15664e] {\n  min-height: 0px;\n  color: red;\n}", ""]);

// exports
